import { useTranslation } from "react-i18next";
import Icon from "./Icon";
import { SITE } from "../data/site";

export default function FloatingActions() {
  const { t } = useTranslation();

  return (
    <div className="fsg-float">
      <a
        className="fsg-float__btn fsg-float__btn--wa"
        href={`https://wa.me/${SITE.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        aria-label={t("cta.whatsapp")}
      >
        <Icon name="whatsapp" />
      </a>
    </div>
  );
}
